import Nullstack from 'nullstack';
export default function IconCircuitVoltmeter({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circuit-voltmeter",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "7"
  }), "   ", Nullstack.element("path", {
    d: "M5 12h-3"
  }), "   ", Nullstack.element("path", {
    d: "M19 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M10 10l2 4l2 -4"
  }), " ");
}